import React from 'react'
import classes from './Sidebar.scss'
import { Link, browserHistory } from 'react-router'

class Sidebar extends React.Component {

  constructor (props) {
    super(props)

    const self: any = this
    self.logout = self.logout.bind(this)
    self.hideBar = self.hideBar.bind(this)
  }

  componentWillUnmount () {
    this.hideBar()
  }

  logout () {
    const { baseUrl, setUsername } = this.props

    fetch(`${baseUrl}/logout`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          setUsername('')
          browserHistory.push('/')
        }
      })
  }

  hideBar () {
    const { toggleSidebar } = this.props
    toggleSidebar(false)
  }

  render () {
    const { className } = this.props
    const sidebarClasses = [classes.sidebar, className].join(' ')
    return (
      <ul className={sidebarClasses}>
        <li><Link to='/' onClick={this.hideBar}>Home</Link></li>
        <li><Link to='/list_solo' onClick={this.hideBar}>Solo</Link></li>
        <li><Link to='/list_versus' onClick={this.hideBar}>Versus</Link></li>
        <li><Link to='/challenges' onClick={this.hideBar}>Challenges</Link></li>
        <li><Link to='/friends' onClick={this.hideBar}>Friends</Link></li>
        <li><Link to='/leaderboards' onClick={this.hideBar}>Leaderboards</Link></li>
        <li><Link to='/rules' onClick={this.hideBar}>Rules</Link></li>
        <li onClick={this.logout} className={classes.logout}>Logout</li>
      </ul>
    )
  }
}

export default Sidebar



/** WEBPACK FOOTER **
 ** ./src/components/Sidebar.js
 **/